import React from 'react';
import Button from '../../components/Button';
import KesslerAssessmentResult from '../../components/KesslerAssessmentResult';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../core/app_state_config';
import './result-score.scss';
import { reset } from '../../core/actions';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from "firebase/firestore";
import db from '../../core/firebase-config';

const ResultScore: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appState = useSelector((state: RootState) => state.app);
    const first_name = appState.personal_form.first_name;
    const form = { ...appState.form };
    const [score, setScore] = React.useState<number>(0);

    React.useEffect(() => {
        const _score: number = Object.values(form).reduce((totalScore, value: any) => totalScore + value.score, 0) as number;
        setScore(_score);
        return;
    }, [form]);

    const getText = () => {
        if (score >= 0 && score <= 19) {
            return "Your assessment results are in, and they suggest you're likely experiencing a good level of mental well-being. It's great to see, and we're here if you ever wish to talk about your mental health.";
        } else if (score >= 20 && score <= 24) {
            return "Thank you for taking the time to complete this assessment. Your results indicate a possibility of mild psychological distress. It’s common to experience periods of stress or discomfort, and there are many resources available to help. We're here to support you whenever you're ready.";
        } else if (score >= 25 && score <= 29) {
            return "We appreciate your effort in completing this assessment. Your score suggests you may be dealing with moderate psychological distress. It's important to recognize how you're feeling, and we want to assure you that support is available. Engaging with professional support can be a positive step forward. Please consider scheduling a time to discuss how we can best support your needs and wellbeing.";
        } else {
            return "Thank you for completing the assessment. Your score indicates that you may be experiencing significant psychological distress. It’s really important to know that you’re not alone, and there are many ways to get support. Taking care of your mental health is a strength, not a weakness, and reaching out for help is a brave step. We encourage you to connect with us or a healthcare professional to explore supportive options tailored to your needs.";
        }
    };
    async function see_treament_options() {
        try {
            await addDoc(collection(db, "kessler_ten__assessment"), appState);
            navigate('/', { replace: true });
            setTimeout(() => {
                dispatch(reset());
                window.open('https://calendly.com/tms-ketamine/30min', '_self');
            }, 500)
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div className="result-score">
            <h1 className="result-score__title">Fantastic, let's take a closer look at your assessment results together.</h1>
            <h4 className="result-score__subtitle">We're here to clarify what these results indicate and discuss how we can support you.</h4>
            <KesslerAssessmentResult score={score} />
            <h1 className="result-score__title" style={{ marginTop: '2rem' }}>You're in good hands, {first_name}.</h1>
            <h4 className="result-score__subtitle">{getText()}</h4>
            <h4 className="result-score__subtitle">Our team specializes in treating various forms of anxiety and depression, ensuring comprehensive care for your needs.</h4>
            <Button type='primary' onPressed={see_treament_options}>
                {'See treatment options'}
            </Button>
        </div>
    );
}

export default ResultScore;
